import React from 'react';
import {
  ButtonGroup as BPButtonGroup,
  ButtonGroupProps
} from '@blueprintjs/core';

const ButtonGroup: React.FC<ButtonGroupProps> = ({ children, ...props }) => {
  return <BPButtonGroup {...props}>{children}</BPButtonGroup>;
};

export default ButtonGroup;
